// extracted by mini-css-extract-plugin
export default {"numeric":"Numeric_numeric__D09Js"};